import classNames from 'classnames'

import { ListingPicture } from '../ListingPicture'
import styles from './styles.module.scss'
import { ListingCardProps } from './types'

export const ListingCard = ({
  imageUrl,
  imageAlt,
  title,
  price,
  onClick,
  subtitle,
  showSubtitle = false,
  className,
}: ListingCardProps) => {
  const pictureSize = showSubtitle ? 'large' : 'medium'
  const infoClassName = classNames(styles.info, {
    [styles.withoutSubtitle]: !showSubtitle,
  })
  const cardClassName = classNames(styles.card, className)

  return (
    <div className={cardClassName} onClick={onClick}>
      <div className={styles.cardContent}>
        <ListingPicture
          url={imageUrl}
          alt={imageAlt}
          size={pictureSize}
          showPlaceholder
        />
        <div className={infoClassName}>
          <div className={styles.price}>{price}</div>
          {title && <div className={styles.title}>{title}</div>}
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
      </div>
    </div>
  )
}
